<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9931_22883)">
      <rect width="71" height="52" fill="white" />
      <path
        opacity="0.8"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63.8928 3.72154C63.8928 5.82219 62.1899 7.52511 60.0892 7.52511C57.9886 7.52511 56.2857 5.82219 56.2857 3.72154C56.2857 1.62089 57.9886 -0.0820312 60.0892 -0.0820312C62.1899 -0.0820312 63.8928 1.62089 63.8928 3.72154ZM57.3724 26.1807C57.3724 38.6846 47.236 48.821 34.7321 48.821C22.2282 48.821 12.0918 38.6846 12.0918 26.1807C12.0918 13.6768 22.2282 3.54042 34.7321 3.54042C47.236 3.54042 57.3724 13.6768 57.3724 26.1807ZM68.0586 10.4231C69.159 10.4231 70.051 9.53107 70.051 8.43072C70.051 7.33038 69.159 6.43838 68.0586 6.43838C66.9583 6.43838 66.0663 7.33038 66.0663 8.43072C66.0663 9.53107 66.9583 10.4231 68.0586 10.4231Z"
        fill="url(#paint0_radial_9931_22883)"
      />
      <path
        d="M47.8007 15.9668C41.0882 12.4647 29.4184 10.1535 24.4226 9.43568L21.1385 23.0287C32.3266 24.4185 40.1323 27.5465 42.6367 28.9367L47.8007 15.9668Z"
        fill="url(#paint1_radial_9931_22883)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.195 12.8564L23.7913 19.2572C23.9995 19.2575 24.1968 19.3038 24.373 19.401C25.1313 19.8196 25.2285 21.0321 24.6237 22.1753C26.8045 22.539 28.8275 22.967 30.6711 23.4235C29.9456 22.0997 29.7391 20.2001 30.2348 18.1724C30.8882 15.5 32.5759 13.3643 34.4212 12.6095C31.5316 11.8571 28.8133 11.2795 26.823 10.9119C26.5514 11.9214 25.9007 12.7067 25.195 12.8564ZM45.0228 16.486C44.3089 17.6672 44.3611 18.9769 45.133 19.436L42.8158 25.4444C42.3604 25.5744 41.9398 25.8812 41.6688 26.3289C41.5184 26.5773 41.4305 26.8421 41.4007 27.1041C40.1569 26.4906 38.1251 25.6423 35.4341 24.7746C37.1032 23.8817 38.5793 21.8777 39.1803 19.4195C39.729 17.1755 39.4175 15.0883 38.4943 13.7649C40.8739 14.5016 43.1964 15.3429 45.1632 16.2699C45.1146 16.3396 45.0677 16.4117 45.0228 16.486ZM28.2018 16.6009C28.1214 17.2318 27.6414 17.7465 27.1297 17.7505C26.6179 17.7545 26.2682 17.2463 26.3486 16.6154C26.429 15.9845 26.909 15.4698 27.4208 15.4658C27.9325 15.4618 28.2822 15.97 28.2018 16.6009ZM41.7667 22.4471C42.2229 22.4436 42.6565 21.9384 42.7353 21.3188C42.8141 20.6992 42.5081 20.1998 42.0519 20.2034C41.5957 20.2069 41.1621 20.7121 41.0833 21.3317C41.0046 21.9513 41.3105 22.4507 41.7667 22.4471Z"
        fill="url(#paint2_radial_9931_22883)"
      />
      <ellipse
        cx="2.81096"
        cy="4.81264"
        rx="2.81096"
        ry="4.81264"
        transform="matrix(1.05693 0.155553 -0.20885 0.875127 32.7412 14.1465)"
        fill="url(#paint3_radial_9931_22883)"
      />
      <path
        d="M45.1073 25.9243C37.2061 26.3141 25.65 30.0331 20.8595 31.8439L25.8278 44.3591C36.4303 40.1285 45.0731 38.9148 48.0692 38.8367L45.1073 25.9243Z"
        fill="url(#paint4_radial_9931_22883)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.8162 27.4909C43.0627 28.4654 43.7125 29.1984 44.4464 29.2876L46.0241 35.4162C45.4212 35.6893 45.0317 36.3127 45.0874 37.0312C45.1169 37.4118 45.2668 37.7618 45.497 38.0445C44.0579 38.1574 41.9659 38.4273 39.3978 38.9384C40.4468 37.4171 40.6148 35.0313 39.6596 32.7134C38.8258 30.6902 37.332 29.1936 35.737 28.5689C38.175 28.0611 40.6188 27.6627 42.8162 27.4909ZM24.4063 31.5905C24.9785 32.7263 24.8126 33.9605 24.006 34.3995C23.9118 34.4508 23.8127 34.4891 23.7103 34.5149L26.3487 40.5469C26.4483 40.5187 26.5521 40.5031 26.6592 40.5015C27.3751 40.4902 28.036 41.1022 28.3583 41.9801C30.5098 41.2251 32.5595 40.6026 34.4646 40.0924C32.9846 39.4052 31.6243 37.972 30.8432 36.0768C29.835 33.6303 30.0781 31.1081 31.2878 29.6067C28.673 30.2765 26.2609 30.9927 24.4063 31.5905ZM28.6365 36.0178C28.9409 36.5549 28.8082 37.1962 28.3402 37.4501C27.8722 37.704 27.2461 37.4744 26.9418 36.9374C26.6374 36.4003 26.7701 35.759 27.2381 35.5051C27.7061 35.2512 28.3322 35.4808 28.6365 36.0178ZM43.2419 33.6837C43.6609 33.456 43.7578 32.8423 43.4582 32.313C43.1587 31.7836 42.5762 31.5391 42.1572 31.7667C41.7382 31.9944 41.6414 32.6081 41.9409 33.1375C42.2404 33.6668 42.8229 33.9114 43.2419 33.6837Z"
        fill="url(#paint5_radial_9931_22883)"
      />
      <ellipse
        cx="3.22699"
        cy="4.1103"
        rx="3.22699"
        ry="4.1103"
        transform="matrix(0.928838 -0.35162 0.365184 0.938075 30.7534 31.6758)"
        fill="url(#paint6_radial_9931_22883)"
      />
      <path
        d="M18.9282 33.8833C18.9282 33.4285 19.1575 33.0043 19.538 32.7551L43.1147 17.318C43.3343 17.1743 43.591 17.0977 43.8534 17.0977L48.9004 17.0977C49.6451 17.0977 50.2488 17.7014 50.2488 18.4462V33.9865C50.2488 34.7312 49.6451 35.335 48.9003 35.335H20.2767C19.5319 35.335 18.9282 34.7312 18.9282 33.9865L18.9282 33.8833Z"
        fill="url(#paint7_radial_9931_22883)"
      />
      <g opacity="0.5" filter="url(#filter0_f_9931_22883)">
        <path
          d="M52.5259 19.3026C45.0977 17.794 33.0928 18.7744 28.0188 19.4531L28.0678 33.3164C39.3785 31.5885 47.7891 32.4419 50.5806 33.0845L52.5259 19.3026Z"
          fill="url(#paint8_radial_9931_22883)"
        />
      </g>
      <path
        d="M52.5259 19.3026C45.0977 17.794 33.0928 18.7744 28.0188 19.4531L28.0678 33.3164C39.3785 31.5885 47.7891 32.4419 50.5806 33.0845L52.5259 19.3026Z"
        fill="url(#paint9_radial_9931_22883)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.4654 23.5393C50.522 23.551 50.5795 23.5576 50.6378 23.5593L49.5675 30.3296C49.3579 30.5586 49.1875 30.8354 49.0794 31.1447C49.0218 31.3094 48.9855 31.473 48.969 31.6319C47.4688 31.3579 44.6787 31.0758 40.9269 31.11C43.1885 30.2096 45.0331 27.6223 45.2489 24.8321C45.497 21.6258 43.5004 19.3658 40.7895 19.7842C38.0786 20.2026 35.6799 23.1411 35.4318 26.3474C35.2491 28.7097 36.2848 30.5584 37.9269 31.2006C35.8916 31.3036 33.6511 31.4995 31.2425 31.8247C31.273 31.7499 31.3018 31.6736 31.3287 31.596C31.7978 30.2413 31.4983 29.0019 30.6598 28.8278C30.3722 28.7681 30.0586 28.8415 29.7517 29.0183L29.8046 21.8758C30.394 21.5427 30.8497 20.9598 31.0465 20.3007C35.6899 19.754 44.2257 19.1363 50.1466 20.0045C50.0103 20.2398 49.8913 20.4973 49.7965 20.7711C49.3275 22.1258 49.627 23.3652 50.4654 23.5393ZM33.7232 25.1264C33.761 25.672 33.2867 26.2369 32.6637 26.3882C32.0408 26.5394 31.505 26.2198 31.4672 25.6743C31.4293 25.1287 31.9036 24.5638 32.5266 24.4125C33.1495 24.2612 33.6853 24.5809 33.7232 25.1264ZM48.0197 27.1493C48.5855 27.0128 49.0135 26.4633 48.9757 25.922C48.9379 25.3807 48.4486 25.0526 47.8828 25.1891C47.317 25.3257 46.889 25.8752 46.9268 26.4165C46.9646 26.9578 47.454 27.2859 48.0197 27.1493Z"
        fill="url(#paint10_radial_9931_22883)"
      />
      <ellipse
        cx="3.35924"
        cy="4.1169"
        rx="3.35924"
        ry="4.1169"
        transform="matrix(1.03964 -0.118784 -0.00701841 0.950846 36.877 22.0723)"
        fill="url(#paint11_radial_9931_22883)"
      />
      <path
        d="M50.249 33.8833C50.249 33.4285 50.0197 33.0043 49.6392 32.7551L26.0625 17.318C25.843 17.1743 25.5863 17.0977 25.3239 17.0977L20.2769 17.0977C19.5322 17.0977 18.9284 17.7014 18.9284 18.4462V33.9865C18.9284 34.7312 19.5322 35.335 20.2769 35.335H48.9006C49.6453 35.335 50.249 34.7312 50.249 33.9865L50.249 33.8833Z"
        fill="url(#paint12_radial_9931_22883)"
      />
      <g opacity="0.5" filter="url(#filter1_f_9931_22883)">
        <path
          d="M34.6043 17.1016L20.4635 17.1016C19.2223 17.1016 18.6403 18.6369 19.5697 19.4597L26.8052 25.8648C27.0517 26.0831 27.3697 26.2036 27.699 26.2036L42.0208 26.2036L49.6389 19.4597C50.5684 18.6369 49.9864 17.1016 48.7451 17.1016L34.6043 17.1016Z"
          fill="url(#paint13_radial_9931_22883)"
        />
      </g>
      <g opacity="0.5" filter="url(#filter2_f_9931_22883)">
        <path
          d="M34.6042 35.3066L48.7449 35.3066C49.9862 35.3066 50.5682 33.7713 49.6388 32.9485L42.4033 26.5434C42.1568 26.3251 41.8388 26.2046 41.5095 26.2046L27.1877 26.2046L19.5696 32.9485C18.6401 33.7713 19.2221 35.3066 20.4634 35.3066L34.6042 35.3066Z"
          fill="url(#paint14_radial_9931_22883)"
        />
      </g>
      <path
        d="M34.6042 35.3066L48.7174 35.3066C49.9621 35.3066 50.5422 33.7642 49.606 32.944L35.4928 20.5781C34.9842 20.1324 34.2241 20.1324 33.7155 20.5781L19.6023 32.944C18.6661 33.7642 19.2463 35.3066 20.4909 35.3066L34.6042 35.3066Z"
        fill="url(#paint15_radial_9931_22883)"
      />
      <path
        d="M34.6043 17.1016L20.4911 17.1016C19.2464 17.1016 18.6663 18.644 19.6025 19.4642L33.7157 31.8301C34.2243 32.2758 34.9844 32.2758 35.493 31.8301L49.6062 19.4642C50.5424 18.644 49.9622 17.1016 48.7176 17.1016L34.6043 17.1016Z"
        fill="url(#paint16_radial_9931_22883)"
      />
      <path
        d="M40.5037 26.2028C40.5037 29.5541 37.787 32.2708 34.4357 32.2708C31.0844 32.2708 28.3677 29.5541 28.3677 26.2028C28.3677 22.8515 31.0844 20.1348 34.4357 20.1348C37.787 20.1348 40.5037 22.8515 40.5037 26.2028Z"
        fill="url(#paint17_radial_9931_22883)"
      />
      <path
        d="M34.943 27.1729C34.6073 27.1743 34.2787 27.1572 33.9469 27.2121C33.156 27.3426 32.4225 27.7956 31.9613 28.4218C31.8755 28.5384 31.694 28.8898 31.5994 28.943C31.404 29.0524 31.1864 28.9256 31.1669 28.716C31.0339 27.2724 31.6405 25.894 32.9415 25.1376C33.5477 24.7851 34.2326 24.6134 34.943 24.6164V23.4149C34.943 23.3907 34.993 23.285 35.0139 23.2615C35.1036 23.1586 35.2837 23.135 35.3954 23.2189C36.1526 23.9886 36.9506 24.7258 37.6996 25.5027C37.7553 25.5603 37.8935 25.6901 37.929 25.7423C37.9942 25.8381 37.99 25.9649 37.9212 26.0569L35.3954 28.5708C35.2837 28.6546 35.1036 28.6311 35.0139 28.5282C34.9934 28.5046 34.943 28.3986 34.943 28.3748V27.1732V27.1729Z"
        fill="url(#paint18_radial_9931_22883)"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_9931_22883"
        x="26.6706"
        y="17.1594"
        width="27.2037"
        height="17.5055"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.674225"
          result="effect1_foregroundBlur_9931_22883"
        />
      </filter>
      <filter
        id="filter1_f_9931_22883"
        x="17.7639"
        y="15.7531"
        width="33.6808"
        height="11.7985"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.674225"
          result="effect1_foregroundBlur_9931_22883"
        />
      </filter>
      <filter
        id="filter2_f_9931_22883"
        x="17.7639"
        y="24.8566"
        width="33.6808"
        height="11.7985"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.674225"
          result="effect1_foregroundBlur_9931_22883"
        />
      </filter>
      <radialGradient
        id="paint0_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(60.1856 -12.9817) rotate(116.919) scale(75.3591 78.4269)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.0552 40.347) rotate(-113.486) scale(39.1797 43.3151)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(26.2302 14.9462) rotate(38.2674) scale(28.343 22.3243)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0.552976 4.32441) rotate(37.8013) scale(9.33127 12.2344)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(55.0211 47.824) rotate(-148.046) scale(40.5628 41.0548)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.8795 34.1996) rotate(14.8642) scale(30.7159 21.702)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0.634817 3.69332) rotate(29.9892) scale(9.7726 11.4538)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57.8614 39.6322) rotate(-149.707) scale(45.0898 43.8105)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(40.3424 23.486) rotate(106.306) scale(37.065 48.8625)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(53.7368 43.8549) rotate(-128.604) scale(38.4103 44.2512)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.3768 23.5813) rotate(27.6914) scale(28.2836 24.4005)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0.660834 3.69924) rotate(29.0421) scale(10.0783 11.58)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.7608 69.7052) rotate(-90) scale(61.7262 60.576)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.714491" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint13_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.3745 20.3395) rotate(92.9915) scale(17.6169 67.3921)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint14_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.834 32.0687) rotate(-87.0085) scale(17.6169 67.3921)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint15_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(60.9059 16.1455) rotate(156.273) scale(48.0627 39.4961)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint16_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.7729 31.9345) rotate(-90) scale(23.7664 19.7372)"
      >
        <stop stop-color="#E7EBF2" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint17_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.5145 23.6355) rotate(89.0506) scale(19.0235 23.1342)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint18_radial_9931_22883"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.6347 30.3534) rotate(-139.481) scale(11.1626 12.2989)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <clipPath id="clip0_9931_22883">
        <rect width="71" height="52" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
